<div class="padding">
    <div class="flex-container">
        <h1 class="left-box">{{ 'bundles.addBundle' | transloco }}</h1>
    </div>
    <mat-card>
        <mat-card-content>
            <div class="flex-container">
                <mat-form-field class="form-field" appearance="outline">
                    <mat-label>{{ 'common.labels.name' | transloco }}</mat-label>
                    <input matInput name="name" [(ngModel)]="this.newBundle.name" [placeholder]="'common.labels.name' | transloco">
                </mat-form-field>
            </div>
            <div class="flex-container">
                <mat-form-field class="form-field" appearance="outline">
                    <mat-label>{{ 'common.labels.description' | transloco }}</mat-label>
                    <textarea matInput name="description" [(ngModel)]="this.newBundle.description" [placeholder]="'common.labels.description' | transloco"></textarea>
                </mat-form-field>
            </div>
            <div class="flex-container">
                <span class="spacer"></span>
                <button mat-raised-button (click)="saveBundle()" color="accent" class="apply-padding"
                    [attr.aria-label]="'bundles.saveColleciton' | transloco" [class.spinner]="this.isSaving"
                    [disabled]="this.isSaving">
                    {{ 'common.buttons.save' | transloco }}
                </button>
            </div>
        </mat-card-content>
    </mat-card>
</div>
